<template>
  <div class="d-flex align-center pa-3 pa-sm-4">
    <v-row>
      <v-col cols="10" sm="auto">
        <default-select
          v-model="dashboardFilters.period"
          :items="$options.dateTypes"
          item-text="key"
          item-value="id"
          class="metrics-filter-select"
          :label="$t('periodFilter')"
          persistent-placeholder
          background-color="white"
          hide-details
          translate-items
        >
        </default-select>
      </v-col>
      <v-col cols="2" sm="auto">
        <v-btn
          v-if="isMobile"
          class="mx-0"
          icon
          @click.stop="$emit('refresh-data')"
        >
          <v-icon v-if="isMobile" size="30" color="primary"
            >$refreshDashBoard</v-icon
          >
        </v-btn>
        <v-btn
          v-else
          class="mx-0"
          color="primary"
          @click.stop="$emit('refresh-data')"
        >
          {{ $t("refreshData") }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import isMobile from "@/mixins/isMobile";
import DefaultSelect from "@/components/formFields/DefaultSelect";
import { metricDateTypes } from "@/static/staticData";

const defaultFilters = {
  period: 1,
};

export default {
  name: "MetricsFilters",
  dateTypes: metricDateTypes,
  components: {
    DefaultSelect,
  },
  mixins: [isMobile],
  data() {
    return {
      dashboardFilters: {
        period: 1,
      },
    };
  },
  computed: {
    ...mapState(["currentHotel"]),
  },
  watch: {
    dashboardFilters: {
      deep: true,
      handler(val) {
        const filters = JSON.parse(JSON.stringify(val));
        this.$emit("update:filters", filters);
      },
    },
    currentHotel: {
      immediate: true,
      handler(val) {
        if (val) {
          this.dashboardFilters = JSON.parse(JSON.stringify(defaultFilters));
        }
      },
    },
  },
};
</script>
